export default __webpack_public_path__ + "static/besteasy-screen-7ebb9ee1c302b642f5f60ff671c947c7.png";